import {
  getSponsorInfo,
  i18nTranslate,
  isGuestCheckoutEnabledForWeb,
  isFeatureEnabled,
} from 'src/utils'
import { FormInputLabels, accountTypeTranslation } from 'src/deps'
import { customerContainer, accountsContainer } from 'src/models'
const changeAccountCardForm = props => {
  const formInputLabels = new FormInputLabels()
  const {
    firstName = '',
    lastName = '',
    preferredName = '',
    sponsorId = '',
  } = props
  const getSponsorFullName = () => `${firstName} ${lastName}`

  const sponsorDisplayName = isFeatureEnabled('enableGraphqlApiForSponsor')
    ? preferredName || getSponsorFullName()
    : getSponsorFullName()
  let isValidHouseSponsor = false
  const enabledGuestForWeb = isGuestCheckoutEnabledForWeb()

  const accountType =
    customerContainer?.profileResponse?.accounts?.accountType || ''
  const accProperties = accountsContainer?.profileResponse?.properties
  const spid =
    accProperties &&
    accProperties.find(list => list.attributeId === 'sponsorId')
  const accountSponsorId = spid?.value || ''
  const sponsorInfo = getSponsorInfo(accountSponsorId)

  if (
    enabledGuestForWeb &&
    accountType === 'Retail Customer' &&
    sponsorInfo.isInHouseSponsor
  ) {
    isValidHouseSponsor = true
  }
  return [
    [
      {
        name: 'changeAccountTypeName',
        type: 'text',
        columnType: {
          lg: '6',
        },
        maxLength: 50,
        defaultValue:
          accountTypeTranslation(
            customerContainer?.profileResponse?.accounts?.accountType
          ) || '',
        disabled: true,
        required: true,
        dataTestId: 'qa-account-type-text',
      },
      ...((!isValidHouseSponsor && [
        {
          name: 'sponsorAffiliateName',
          type: 'text',
          toolTipInfo: formInputLabels.getFormLabels('whatIsThisMessage') || '',
          toolTipAction: 'click',
          showBAMessage: true,
          toolTipId: 'sponsorTooltip',
          columnType: {
            lg: '6',
          },
          maxLength: 50,
          defaultValue:
            sponsorId !== 'RETFLOAT'
              ? sponsorDisplayName
              : i18nTranslate(
                  'sponsorChange.pendingSponsor',
                  'Pending Sponsor'
                ),
          disabled: true,
          required: true,
        },
      ]) ||
        []),
    ],
  ]
}
export { changeAccountCardForm }
